import type { Flag } from '~/shared/api/data-ingestion-api/client'

/** Returns the first flag matching flagType with unresolved status, or null. */
export function getActiveFlagByType(flags: Flag[], flagType: string): Flag | null {
  return flags.find((flag) => flag.flag_type === flagType && flag.flag_status === 'pending') ?? null
}
